import React from "react";
import { Box, Typography } from "@mui/material";

function About() {
  return (
    <Box id="about" sx={{ textAlign: "justify", margin: "40px 0" }}>
      <h2
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "30px",
          color: "#333",
          textTransform: "uppercase", // Make the title unique
          borderBottom: "2px solid #ffd700", // Add a unique underline
          display: "inline-block",
          paddingBottom: "10px",
        }}
      >
        Бидний тухай
      </h2>
      <Typography variant="body1" sx={{ marginBottom: "10px" }}>
        Манай Өмгөөллийн “юү энд би адвокатс” хуулийн компани нь үйлчлүүлэгчийнхээ эрх, хууль ёсны ашиг сонирхлыг
        хуульд үл харшлах бүхий л арга хэрэгслийг ашиглан тууштай хамгаалахын төлөө үнэнч, шударгаар ажилладаг
        хамт олон юм.
      </Typography>
      <Typography variant="body1">
        САЛБАР БҮРТЭЭ МЭРГЭШСЭН, МАНЛАЙЛАГЧ ХАМТ ОЛОН ТАНЫ БИЗНЕСИЙН ҮЙЛ АЖИЛЛАГААГ ӨРГӨЖҮҮЛЭХЭД ТУСЛАХ БОЛНО.
      </Typography>
    </Box>
  );
}

export default About;